import React from 'react'
import withRedux from 'next-redux-wrapper'
import Head from 'next/head'
import Parser from 'html-react-parser'
import Theme from 'components/Theme'
import { App, Store } from 'apps/public/wpCms'
import { storeSetup } from 'lib/pageSetup'
import { Actions as SiteContextActions } from 'actions/siteContext'

const METADATA = {
  title: 'ignore',
  description: 'ignore',
  robots: true,
}

const Worpress = ({ appHead, className, html, navigationParams }: Record<string, any>) => {
  const metaTags = Parser(`${appHead}`)
  return (
    <>
      <Head>{metaTags}</Head>

      <Theme>
        <App className={className} html={html} navigationParams={navigationParams} />
      </Theme>
    </>
  )
}

Worpress.getInitialProps = async ({ query, req, res, store }) => {
  // Client-Side
  if (!req) {
    return {}
  }

  // SSR Logic
  storeSetup(store, req)

  if (query.siteContext) {
    store.dispatch(SiteContextActions.SET_SITE_CONTEXT(query.siteContext))
  }
  // Akamai Tag
  res.set('Edge-Cache-Tag', `page-wp page-stories`)
  // MetaData
  return { ...query, metaData: METADATA } // query => { datalayer, head, html }
}

export default withRedux(Store)(Worpress)
